// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1336":"dda80534","1628":"dda80534","5657":"dda80534","6586":"575d1a99","8477":"46f3d60f","9094":"d4c2e551","9472":"1907ce65"}[chunkId] + ".chunk.css";
};